import format from 'date-fns/format';
import { ru } from 'date-fns/locale'

export const formatDateStr = (dateStr, _format = 'dd.MM.yyyy HH:mm') => format(new Date(dateStr), _format, { locale: ru, weekStartsOn: 1 });
export const formatTime = int => format(new Date(int * 1000), 'dd.MM.yyyy HH:mm');
